module.exports = __webpack_public_path__ + "static/media/R-Smart MotorE-en.ebc26188.jpg";